
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

interface StatsSectionProps {
  hideTitle?: boolean;
}

const AnimatedStat = ({ value, label }: { value: string; label: string }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });
  
  return (
    <motion.div 
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
      transition={{ duration: 0.7 }}
      className="text-center py-4"
    >
      <motion.div 
        initial={{ scale: 0.8 }}
        animate={isInView ? { scale: 1 } : { scale: 0.8 }}
        transition={{ 
          type: "spring", 
          stiffness: 100, 
          duration: 0.8,
          delay: 0.2
        }}
        className="stat-value text-3xl md:text-4xl font-bold text-white mb-2"
      >
        {value}
      </motion.div>
      <div className="stat-label text-munger-lightgray text-sm md:text-base">{label}</div>
    </motion.div>
  );
};

const StatsSection = ({ hideTitle = false }: StatsSectionProps) => {
  return (
    <section className="stats-section">
      {!hideTitle && (
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="section-title text-center mb-12"
        >
          Results In Beta Testing
        </motion.h2>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <AnimatedStat value="40,000+" label="AUTOMATED LEADS" />
        <AnimatedStat value="7,200+" label="AUTOMATED SALES MEETINGS" />
        <AnimatedStat value="430,000+" label="AUTOMATED USERS" />
      </div>
    </section>
  );
};

export default StatsSection;
